import { useMemo } from 'react';

import { isNonEnglish } from 'src/data/generation';
import { TEXT_DETAILS_PANEL_TAB } from 'src/data/ui';
import * as events from 'src/lib/events';
import { createStateSelectorHook } from 'src/lib/sweetState';
import { useTrackingEvent } from 'src/services/useTrackingEvent';
import { UiStore, useUiActions } from 'src/store/ui';

const useUiState = createStateSelectorHook(UiStore, ['textDetailsPanelTab']);

export const useTabProps = ({ language, isGeneralTextTool }) => {
  const trackEvent = useTrackingEvent();
  const uiActions = useUiActions();

  const { textDetailsPanelTab } = useUiState();
  const showTabs = !isNonEnglish(language) && !isGeneralTextTool;

  return useMemo(() => {
    const handleSelectTab = (newTab) => {
      trackEvent(events.DOCUMENT.insightsPanelTabChanged, {
        page: events.EVENT_PAGE.editor,
        tab: newTab,
      });
      uiActions.setTextDetailsPanelTab(newTab);
    };

    const selectedTab = showTabs ? textDetailsPanelTab : TEXT_DETAILS_PANEL_TAB.brandPolicy;
    const availableTabs = showTabs
      ? [TEXT_DETAILS_PANEL_TAB.performance, TEXT_DETAILS_PANEL_TAB.brandPolicy]
      : [TEXT_DETAILS_PANEL_TAB.brandPolicy];

    return {
      showTabs,
      availableTabs,
      selectedTab,
      onSelectTab: handleSelectTab,
    };
  }, [textDetailsPanelTab, uiActions, trackEvent, showTabs]);
};
